/*
 * Copyright 2023 StarTree Inc.
 *
 * All rights reserved. Confidential and proprietary information of StarTree Inc.
 */
import "@startree-ui/platform-ui/assets/styles/fonts.scss";
import "@startree-ui/platform-ui/assets/styles/layout.scss";
import { enableAllPlugins } from "immer";
import React, { StrictMode } from "react";
import ReactDOM from "react-dom";
import { Root } from "./root";
import { initLocale } from "./utils/locale/locale.util";

// Initialize locale
initLocale();

// Initialize Immer to handle maps and sets
enableAllPlugins();

// App entry point
ReactDOM.render(
    <StrictMode>
        <Root />
    </StrictMode>,
    document.getElementById("root") as HTMLElement
);
